import Scrollbar, {ScrollbarPlugin} from 'smooth-scrollbar';
import { debounce } from 'throttle-debounce';
import { isHomePage } from '../helpers/consts';

import {IS_HOME_VERTICAL, isLandingPage, isPost} from '../helpers/consts';

class HorizontalScrollPlugin extends ScrollbarPlugin {
	static pluginName = 'horizontalScroll';

	static defaultOptions = {
		horizontal: false,
	};

	transformDelta(delta, fromEvent) {
		const { x, y } = delta;
		if(!this.options.horizontal) {
			return {
				y: y,
				x: 0,
			};
		}

		return {
			y: 0,
			x: Math.abs(x) > Math.abs(y) ? x : y,
		};
	}
}

class BlockPlugin extends ScrollbarPlugin {
	static pluginName = 'block';

	static defaultOptions = {
		block: false,
	};

	transformDelta(delta) {
		return this.options.block ? { x: 0, y: 0 } : delta;
	}
}

Scrollbar.use(HorizontalScrollPlugin, BlockPlugin);


class СustomScroll {
	constructor() {
		this.scroller = null;
		this.isGlobalScrolling = false;
		this.isHorizontal = isHomePage && !IS_HOME_VERTICAL;
		this.scrollX = 0;
		this.scrollY = 0;
	}

	init() {
		// **Prevent Smooth Scroll from initializing on Landing Pages**
		// **Disable Smooth Scroll on Landing Pages**
		if (isLandingPage || isPost) {
			console.log("Smooth Scroll disabled on Landing Pages.");
			document.body.style.overflow = "auto";  // Enable normal scrolling
			document.documentElement.style.overflow = "auto";  // Ensure HTML allows scrolling
			return;
		}

		this.wrapper = document.querySelector('.js-scroller-wrapper');

		this.options = {
			damping: 0.25,
			syncCallbacks: true,
			renderByPixels: true,
			plugins: {
				HorizontalScrollPlugin: this.isHorizontal,
				// UpdatePlugin: true,
			},
		// plugins: {
			// 	disableScroll: {
			// 		direction: 'x',
			// 	},
			// },
		};

		this.scroller = Scrollbar.init(this.wrapper, this.options);
		this.scroller.track.xAxis.element.remove();

		if(this.isHorizontal) {
			this.scroller.updatePluginOptions('horizontalScroll', { horizontal: true });

			// const storage = sessionStorage.getItem('scrollNextPage');
			// if(storage !== null && storage !== 'null') {

			// } else {
			// }
			this.disableScroll();
		}

		this.setEvents();


		let currentHash = window.location.hash;
    if (currentHash) {
        history.replaceState(null, null, ' ');
    }
		setTimeout(() => {
			history.replaceState(null, null, currentHash);
			// this.checkScrollTo();
		}, 100);
	}

	scrollToHomeBlock(block){
		if(!block) return;

		const rect = block.getBoundingClientRect();
		if(this.isHorizontal) {
			const verticalContainer = document.querySelector('.js-home-anim-container');
			const isBlockInsideVerticalSection = verticalContainer.contains(block);

			if(isBlockInsideVerticalSection) {
				const innerWrapper = verticalContainer.querySelector('.js-home-anim-container-inner');
				const innerWrapperHeight = innerWrapper.offsetHeight;
				const verticalContainerWidth = verticalContainer.offsetWidth - window.innerWidth;
				const percentH = rect.top / (innerWrapperHeight - rect.top);
				const blockTopPos = verticalContainerWidth * (percentH);
				const finalPos = rect.left + blockTopPos;
				// console.log(`verticalContainerWidth`, verticalContainerWidth)
				// console.log(`innerWrapperHeight`, innerWrapperHeight)
				// console.log(`rect.top `, rect.top)
				// console.log(`percentH`, percentH)
				// console.log(`blockTopPos`, blockTopPos )
				// console.log(rect.left, finalPos)

				this.scroller.scrollTo(finalPos, 0, 10);
			} else {
				// console.log(`outside`)
				this.scroller.scrollTo(rect.left, 0, 10);
			}
		} else {
			this.scroller.scrollTo(0, rect.top, 10);
		}

	}


	checkScrollTo() {
		console.log(`checkScrollTo`)
		let pageUrl = window.location.href;
		// console.log(`pageUrl`, pageUrl)

		const hashPos = pageUrl.indexOf('#');
		// console.log(`hashPos`, hashPos)
		if(hashPos === -1) return;

		let targetID = pageUrl.substring(hashPos);
		const block = document.querySelector(targetID);
		// console.log(`block`, block)
		if(!block) return;

		if(this.isHorizontal) {
			this.scrollToHomeBlock(block);
		} else {
			const rect = block.getBoundingClientRect();
			this.scroller.scrollTo(0, rect.top, 0);
		}

		// if(this.isSimple) return;
		// const storage = sessionStorage.getItem('scrollNextPage');
		// console.log(storage);
		// if(storage !== null && storage !== 'null') {
		// 	const block = document.querySelector(storage);
		// 	if(!block) return;

		// 	if(this.isHorizontal) {
		// 		this.scrollToHomeBlock(block);
		// 	} else {
		// 		const rect = block.getBoundingClientRect();
		// 		this.scroller.scrollTo(0, rect.top, 10);
		// 	}

		// 	sessionStorage.setItem('scrollNextPage', null);
		// }
	}

	disableScroll() {
		// console.log('disableScroll');
		this.scroller.updatePluginOptions('block', { block: true });
	}

	enableScroll() {
		// console.log('enableScroll');
		this.scroller.updatePluginOptions('block', { block: false});
	}

	startScrollChecking = debounce(100, () => {
		this.isGlobalScrolling = false;
	});

	scrollHandle = (status) => {
		// console.log(`scroll`)
		this.isGlobalScrolling = true;
		if(this.isHorizontal) {
			this.scrollX = status.offset.x;
		}
		else {
			this.scrollY = status.offset.y;
		}

		this.startScrollChecking();
	};

	setEvents() {
		// setTimeout(() => {
		this.scroller.addListener(this.scrollHandle);
		// });
	}

	destroy() {
		if(this.scroller) {
			this.scroller.destroy();
			this.scroller = null;
		}
	}
}

const сustomPageScroll = new СustomScroll();
export default сustomPageScroll;
